function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_426",
  "data-name": "Group 426",
  transform: "translate(-976 -279)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_382",
  "data-name": "Group 382",
  transform: "translate(164 -41)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(812 320)",
  fill: "#eeeff3"
})), /*#__PURE__*/React.createElement("g", {
  id: "link_black_24dp",
  transform: "translate(978.015 300) rotate(-45)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_421",
  "data-name": "Group 421"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_148",
  "data-name": "Rectangle 148",
  width: 26.849,
  height: 26.849,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_423",
  "data-name": "Group 423",
  transform: "translate(2.237 7.831)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_422",
  "data-name": "Group 422"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M18.781,7H15.425a1.119,1.119,0,1,0,0,2.237h3.356a3.356,3.356,0,1,1,0,6.712H15.425a1.119,1.119,0,1,0,0,2.237h3.356A5.594,5.594,0,1,0,18.781,7ZM8.712,12.594a1.122,1.122,0,0,0,1.119,1.119h6.712a1.119,1.119,0,0,0,0-2.237H9.831A1.122,1.122,0,0,0,8.712,12.594ZM10.95,15.95H7.594a3.356,3.356,0,0,1,0-6.712H10.95A1.119,1.119,0,0,0,10.95,7H7.594a5.594,5.594,0,0,0,0,11.187H10.95a1.119,1.119,0,1,0,0-2.237Z",
  transform: "translate(-2 -7)",
  fill: "#7d9ef1"
})))));

var SvgWebsite = function SvgWebsite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebsite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/website.2fd25b59.svg";
export { ForwardRef as ReactComponent };